<template>
  <div class="childPannel">
    <div v-if="list.length" class="childPannel-box">
      <div @click="handleClickItem(m)" v-for="(m, i) in list" :key="i" class="childPannel-box-item">
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">名称：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.name }}</span>
          </div>
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">类型：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.type }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />

    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from 'vue'
import { toCameraPosition } from './utils'
import { getAllDataInfo, getBridgeDataDetail, getCameraDetail, getMarkDetail } from '@/apiFzn'
import type { IAllDataDto } from '@/apiFzn/types'
import BridgePopup from '../../Popup/BridgePopup.vue'
import MarkPopup from '../../Popup/MarkPopup.vue'
import CameraPopup from '../../Popup/CameraPopup.vue'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { Cartographic, Math } from 'cesium'
const bridgeId = defineModel<number>('bridgeId')
  const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})

const params = reactive({
  name: '',
  pageNum: 1,
  pageSize: 12,
})

const list = ref<IAllDataDto[]>([])
const total = ref(0)

const getList = () => {
  getAllDataInfo(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}

/** 列表点击事件  */
const handleClickItem = async (m: IAllDataDto) => {
  let result
  let com
  if (m.type === '桥梁') {
    bridgeId.value = m.id
    const { data } = await getBridgeDataDetail({ id: m.id })
    result = data
    com = BridgePopup
  } else if (m.type === '航标') {
    const { data } = await getMarkDetail({ id: m.id })
    result = data
    com = MarkPopup
  } else if (m.type === '摄像头') {
    const { data } = await getCameraDetail({ id: m.id })
    result = data
    com = CameraPopup
  }

  toCameraPosition({
    lng: m.longitude,
    lat: m.latitude,
  })

  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()
  popupCtrl.popupMap.forEach((val) => {
    val.destroy()
  })

  const cartographic = Cartographic.fromDegrees(m.longitude, m.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: com as any,
    properties: result,
  })
}

watch(
  () => props.searchValue,
  (newVal) => {
    params.name = newVal
    params.pageNum = 1
  },
  { immediate: true }
)

defineExpose({
  getList,
})
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
